import React from 'react';
export const WixDesignSystemContext = React.createContext({
    newColorsBranding: true,
    newBrandingClass: 'no-brand',
    mobile: false,
});
//# sourceMappingURL=context.js.map